module.exports = __webpack_public_path__ + "static/media/brl_note_10.50e34739.jpg";